<template>
	<div class="yj-steps" :class="[
       !simple && 'yj-steps--' + direction,
       simple && 'yj-steps--simple'
     ]">
		<slot></slot>
	</div>
</template>

<script>

	export default {
		name: 'YjSteps',

		props: {
			space: [Number, String],
			active: Number,
			direction: {
				type: String,
				default: 'horizontal'
			},
			alignCenter: Boolean,
			simple: Boolean,
			finishStatus: {
				type: String,
				default: 'finish'
			},
			processStatus: {
				type: String,
				default: 'process'
			}
		},

		data() {
			return {
				steps: [],
				stepOffset: 0
			};
		},

		methods: {
			
		},

		watch: {
			active(newVal, oldVal) {
				this.$emit('change', newVal, oldVal);
			},

			steps(steps) {
				steps.forEach((child, index) => {
					child.index = index;
				});
			}
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/steps/src/steps.vue